import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/services';

declare const bootstrap: any;

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        let error: string = '';
        if ([401, 403].includes(err.status) && this.authService.userValue) {
          // 1. Clean up Bootstrap 5 modals and overlays moved to body
          this.cleanupBootstrapModals();
          // auto logout if 401 or 403 response returned from api
          this.authService.logout();
          error = err.error?.message || err.statusText;
        } else if([400].includes(err.status)){
          error =
            err.error?.result ||
            err.error?.Exception ||
            err.error?.message ||
            err.statusText;
        } else if ([500].includes(err.status)) {
          error =
            err.error?.result ||
            err.error?.Exception ||
            err.error?.message ||
            err.statusText;
        }
        return throwError(()=>error);
      })
    );
  }

  private cleanupBootstrapModals(): void {
    // Hide open modals via Bootstrap 5 API
    document.querySelectorAll('.modal.show').forEach((modalEl: Element) => {
      if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
        const modalInstance = bootstrap.Modal.getInstance(modalEl);
        if (modalInstance) {
          modalInstance.hide();
        }
      }
      
      // Force remove from DOM if moved directly to body by script
      if (modalEl.parentNode === document.body) {
        modalEl.parentNode.removeChild(modalEl);
      }
    });

    // Remove remaining backdrops
    document.querySelectorAll('.modal-backdrop').forEach((backdrop: Element) => {
      backdrop.remove();
    });

    // Restore body scrolling state
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('overflow');
    document.body.style.removeProperty('padding-right');
  }
}
